<template>
  <div>
    <!--**********************************
    Main wrapper start
  ***********************************-->
    <div id="main-wrapper">
      <!-- Edit Email Template -->
      <!-- Modal -->
      <div class="modal fade" id="exampleModal-invite-customer-2" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" style="max-width: 1200px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ lan.admin[22].Email[0].Edit_Email }} {{ language }}
              </h5>
              <li class="nav-item dropdown notification_dropdown mr-4">
                <a href="javascript:void(0)" role="button" data-toggle="dropdown">
                  <a v-if="language == 'English'" class="nav-link ai-icon d-flex bg-orange" href="javascript:void(0)">
                    <img src="https://cdn.britannica.com/79/4479-050-6EF87027/flag-Stars-and-Stripes-May-1-1795.jpg"
                      class="flag" alt="" />
                    <span class="pl-2 color">En</span>
                  </a>
                  <a v-else-if="language == 'Swedish'" class="nav-link ai-icon d-flex bg-orange"
                    href="javascript:void(0)">
                    <img
                      src="https://upload.wikimedia.org/wikipedia/en/thumb/4/4c/Flag_of_Sweden.svg/1200px-Flag_of_Sweden.svg.png"
                      class="flag" alt="" />
                    <span class="pl-2 color">Sw</span>
                  </a>
                </a>
                <div class="dropdown-menu dropdown-menu-right p-0" style="min-width: 190px">
                  <div id="dlab_W_Notification1" class="widget-media p-3">
                    <ul class="timeline ml-4">
                      <li>
                        <div class="timeline-panel" @click="switchLanguag('English')">
                          <a class="nav-link ai-icon d-flex bg-orange" href="javascript:void(0)">
                            <img
                              src="https://cdn.britannica.com/79/4479-050-6EF87027/flag-Stars-and-Stripes-May-1-1795.jpg"
                              class="flag" alt="" />
                            <span class="pl-3 color">English</span>
                          </a>
                        </div>

                        <div class="timeline-panel" @click="switchLanguag('Swedish')">
                          <a class="nav-link ai-icon d-flex bg-orange" href="javascript:void(0)">
                            <img
                              src="https://upload.wikimedia.org/wikipedia/en/thumb/4/4c/Flag_of_Sweden.svg/1200px-Flag_of_Sweden.svg.png"
                              class="flag" alt="" />
                            <span class="pl-3 color">Swedish</span>
                          </a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-md-4 p-3">
              <div class="input">
                <span class="mr-3">{{ lan.admin[22].Email[0].Subject }}:</span>
                <input style="width: 40%" type="text" v-model="subject" />
              </div>

              <ckeditor :editor="editor" v-model="partner_email_body" :config="editorConfig"></ckeditor>
            </div>
            <div class="modal-footer">
              <button id="email_template_close" type="button" class="search-btn up-btn mb-0" data-dismiss="modal">
                {{ lan.admin[22].Email[0].Close }}
              </button>
              <button type="button" class="filter-btn up-btn mb-0" @click="save()">
                <div class="lds-ring" v-show="loading">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <span v-show="loadingS">
                  {{ lan.admin[4].Opportunity_page[0].Invite_customer_to_quote }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--**********************************
        Content body end
    ***********************************-->
    </div>
    <!--**********************************
    Main wrapper end
  ***********************************-->
  </div>
</template>

<script>
import axios from "axios";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import _ from 'lodash';

export default {
  name: "Email Template",
  data() {
    return {
      value: true,
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
      emailData: '',
      getId: "",
      BodyContent: "",
      partner_email_body: "",
      subject: "",

      loading: false,
      loadingS: true,
      language: 'English'
    };
  },
  mounted() {
    // for top load page
    window.scrollTo(0, 0);
    console.log('mount emailData', this.emailData);
    // this.$watch(
    //   () => ({
    //     props_emailData: this.emailData,
    //   }),
    //   (newValues, oldValues) => {
    //     this.getId = newValues.props_emailData.emailContent.id
    //     this.BodyContent = newValues.props_emailData.emailContent.body
    //     this.subject = newValues.props_emailData.emailContent.subject
    //     this.partner_email_body = newValues.props_emailData.emailContent.partner_email_body

    //     // do whatever you want with the new and old values
    //   },
    //   { deep: true }
    // );

    this.emailContentLoad("mount");
  },

  computed: {
    lan() {
      return this.$store.getters.whichLanguage;
    },
    whichLanguageName() {
      return this.$store.getters.whichLanguageName;
    }
  },
  watch: {
    whichLanguageName(newVal) {
      if (newVal) {
        this.switchLanguag(newVal);
      }
    }
  },

  methods: {
    switchLanguag(Language) {
      this.language = Language;
      this.subject = Language == 'English' ? this.emailData.subject : this.emailData.sw_subject
      this.partner_email_body = Language == 'English' ? (this.emailData.partner_email_body || this.emailData.body) : (this.emailData.sw_partner_email_body || this.emailData.sw_body)
    },
    emailContentLoad(text) {
      console.log(text);
      axios
        .get(axios.defaults.baseURL + "get-email-content/1", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log("res email content--", res);
          this.emailData = res.data.data[0];
          this.getId = res.data.data[0].id;
          this.BodyContent = res.data.data[0].body;
          this.subject = res.data.data[0].subject;
          this.partner_email_body = res.data.data[0].partner_email_body;

          this.language = this.$store.getters.whichLanguageName || 'English';
          this.switchLanguag(this.language);
          //   if(text != 'mount'){
          //   var loader = document.getElementById('loader' + this.getId)
          //     var td = document.getElementById('td' + this.getId)
          //     loader.style.display = 'none';
          //     td.style.display = 'block';
          // }

        })
        .catch((err) => {
          this.$store.dispatch("checkErrorAndSendToast", [
            err.response,
            "error",
          ]);
        });
    },
    save() {
      console.log('save- his.getId--', this.getId);
      this.$emit("email-updated", [1, this.partner_email_body]);
      document.getElementById('email_template_close').click()
      return
      var formData = new FormData();
      formData.append("subject", this.subject);
      formData.append("body", this.BodyContent);
      formData.append("partner_email_body", this.partner_email_body);
      this.loading = true;
      this.loadingS = false;

      axios
        .post(
          axios.defaults.baseURL + "edit-email-content/5",
          formData,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          console.log("post res", res);
          // var loader = document.getElementById('loader' + this.getId)
          // var td = document.getElementById('td' + this.getId)
          // loader.style.display = 'block';
          // td.style.display = 'none';

          this.emailContentLoad("save");
          (this.loading = false),
            (this.loadingS = true),
            this.$emit("email-updated", 1);
          document.getElementById('email_template_close').click()
          this.$store.dispatch("checkErrorAndSendToast", [res, "Success"]);
        })
        .catch((err) => {
          console.log("post err", err);
          (this.loading = false),
            (this.loadingS = true),
            this.$store.dispatch("checkErrorAndSendToast", [res, "Success"]);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loader-show {
  display: none;
}
</style>
